var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.346 14.074c3.209.475 5.72 3.297 5.653 7.005-.058 3.121-2.004 5.976-5.21 8.517-1.132.896-2.349 1.694-3.577 2.386-.77.434-1.4.747-1.814.933-.125.056-.26.085-.398.085-.137 0-.273-.029-.398-.085-.414-.185-1.045-.5-1.814-.933-1.228-.692-2.446-1.49-3.577-2.386-3.206-2.541-5.152-5.395-5.21-8.517-.068-3.708 2.446-6.531 5.651-7.005 2.064-.34 4.132.51 5.348 2.17 1.216-1.66 3.283-2.51 5.346-2.17zm-4.418 4.635c-.118.411-.497.694-.928.694-.43 0-.81-.283-.928-.694-.539-1.865-1.865-2.788-3.514-2.788-.206 0-.413.015-.617.046-2.291.338-4.06 2.3-4.01 5.078.043 2.313 1.51 4.553 4.003 6.648C18.567 29.065 20.39 30.18 22 30.98c1.61-.8 3.433-1.915 5.066-3.287 2.493-2.095 3.96-4.335 4.002-6.648.051-2.778-1.718-4.74-4.009-5.078-1.878-.278-3.521.63-4.13 2.742z",
    transform: "translate(-357 -457) translate(16 435) translate(330 8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.57655c1ce65a9f7324387d161ddec08c.svg";
export { ForwardRef as ReactComponent };